module.exports = "/_next/static/images/apple-touch-icon-ac55d625ad7e94fb9ec0a84b9090cba5.png";